var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.273 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Click to copy the text to your clipboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 240h24v24H20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -5.33 -63.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42.355 257.043a.91.91 0 0 1-.907.907h-1.854v-10.992a2.41 2.41 0 0 0-2.407-2.406H25.906v-2.145a.91.91 0 0 1 .907-.906h14.635a.907.907 0 0 1 .907.907zm-4.261 4.55v-14.635a.91.91 0 0 0-.907-.907l-14.635.001a.906.906 0 0 0-.907.906v14.636a.91.91 0 0 0 .907.906h14.635a.907.907 0 0 0 .907-.907M41.448 240H26.813a2.41 2.41 0 0 0-2.407 2.407v2.144h-1.854a2.41 2.41 0 0 0-2.407 2.407v14.635A2.41 2.41 0 0 0 22.552 264h14.635a2.407 2.407 0 0 0 2.407-2.406v-2.144h1.854a2.41 2.41 0 0 0 2.407-2.407v-14.636A2.41 2.41 0 0 0 41.448 240m-19.803 6.958v14.636a.91.91 0 0 0 .907.906h14.635a.907.907 0 0 0 .907-.907v-14.635a.91.91 0 0 0-.907-.907l-14.635.001a.906.906 0 0 0-.907.906"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4b0d7dd29ac5b33d5044a8ad6d15321c.svg";
export { ForwardRef as ReactComponent };